import { useQuery } from '@tanstack/react-query';
import { fetchJobPositionList } from '@company/services/job/api';
import QueryKeys from '@constants/queryKeys';

export function useJobOptions() {
  const queryJobOptions = [QueryKeys.JOB_TITLES];
  const { data: jobOptions, isLoading } = useQuery({
    queryKey: queryJobOptions,
    queryFn: () => fetchJobPositionList(),
    staleTime: 1000 * 60 * 60, // 1 hour
    refetchOnMount: false, // Do not refetch when component mounts
    refetchOnWindowFocus: false, // Do not refetch when window regains focus
  });

  return {
    jobOptions,
    isLoading,
  };
}
